export default class TemplateGiftCard {
  constructor() {
    return this.addQrCode();
  }

  addQrCode() {
    const qrWrapper = document.querySelector('[data-qr-code]');

    return new QRCode(qrWrapper, {
      text: qrWrapper.dataset.qrCode,
      width: 120,
      height: 120,
    });
  }
}
